module.exports = "/images/wbuy.png?ee168b28cc2cf6fed5ead201f2b50e46";